import React from "react";
import { ClipLoader } from "react-spinners";


const LoadingPop = () => {
    return(
        <div className="pop_wrap flex_center loading_pop">
            <div className="box">
                <ClipLoader
                    color="#008ecd"
                    size={50}
                />
            </div>
        </div>
    );
};

export default LoadingPop;